import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/landing/Header";
import { Footer } from "@/components/landing/Footer";
import { DemoForm } from "@/components/landing/DemoForm";
import { DemoContext } from "@/components/landing/DemoContext";
import { AuditContext } from "@/components/landing/AuditContext";
import { AuditModal } from "@/components/landing/AuditModal";
import { MobileStickyCTA } from "@/components/landing/MobileStickyCTA";
import { useRouteTracker } from "@/access/tracker";
import { SiteScripts } from "@/components/landing/SiteScripts";
import { DocumentHead } from "@/components/landing/DocumentHead";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Hash routing — scroll to element. Retry a few times because some
      // sections lazy-mount via SectionReveal (content-visibility: auto).
      const id = hash.replace("#", "");
      let tries = 0;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return true;
        }
        tries += 1;
        if (tries < 8) setTimeout(tryScroll, 150);
        return false;
      };
      tryScroll();
      return;
    }
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);
  return null;
};

const Tracker = () => {
  const { pathname } = useLocation();
  useRouteTracker(pathname);
  return null;
};

export const Layout = () => {
  const [open, setOpen] = useState(false);
  const [auditOpen, setAuditOpen] = useState(false);
  return (
    <DemoContext.Provider value={() => setOpen(true)}>
      <AuditContext.Provider value={() => setAuditOpen(true)}>
      <ScrollToTop />
      <Tracker />
      <SiteScripts />
      <DocumentHead />
      <Header />
      <main className="overflow-x-hidden">
        <Outlet />
      </main>
      <Footer />
      <MobileStickyCTA />
      <DemoForm open={open} onOpenChange={setOpen} />
      <AuditModal open={auditOpen} onClose={() => setAuditOpen(false)} />
      </AuditContext.Provider>
    </DemoContext.Provider>
  );
};
